export default function ({ store, error }) {
    if (!store.getters.isServer) {
        return error({ statusCode: 401, message: 'You have a lot to learn about this town sweetie.' })
    }
}
